








import {Vue, Component} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {ncpPopup} from '@/utils/ncp';
import { Mall } from 'ncp-api-supporter';
import { hyundaiMallNos, kiaMallNos } from '@/const/mall';
import { NCUA_VUES } from '@/const/common';

Vue.use(require('@/assets/img/logo_footer.png'));

@Component
export default class Footers extends Vue {
  @State('malls', { namespace: 'mall' })
  public malls!: Mall[];

  @State private view!: object;

  private mounted(): void {}

  private canDisplay() {
    if (this.malls.some(({ mallNo }) => hyundaiMallNos.includes(mallNo))) {
      return false;
    }

    if (this.malls.some(({ mallNo }) => kiaMallNos.includes(mallNo))) {
      return false;
    }

    if (NCUA_VUES.includes(this.$route.name || '')) {
      return false;
    }

    return true;
  }

  private onClickPrivacyNoticeLink() {
    window.open(process.env.VUE_APP_PRIVACY_AGREEMENT, '_blank');
  }

  private onClickBusinessInfoLink() {
    ncpPopup('http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1208646911', window.$t('VIEW_LAYOUT_DEFAULT_FOOTER_BUSINESSINFOLINK_NCP') as string, 900, 700);
  }
}
